var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 28,
    viewBox: "0 0 41 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.401 12C30.6254 12 28.1976 13.567 26.8714 15.9064C26.0358 15.4515 25.0874 15.1944 24.0818 15.1944C20.723 15.1944 18 18.061 18 21.5972C18 25.1333 20.723 28 24.0818 28H33.401C37.5977 28 41 24.4182 41 20C41 15.5818 37.5977 12 33.401 12Z",
    fill: "url(#paint0_linear_1640_38191)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1148 0C21.4081 0 17.2916 2.54655 15.043 6.34793C13.6262 5.60868 12.0178 5.19087 10.3127 5.19087C4.61724 5.19067 0 9.84905 0 15.5954C0 21.3418 4.61724 26 10.3127 26H26.1148C33.2311 26 39 20.1797 39 13C39 5.82033 33.2311 0 26.1148 0Z",
    fill: "url(#paint1_linear_1640_38191)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1640_38191",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 27
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3827 0C21.6277 0 17.469 2.55172 15.1973 6.36083C13.7659 5.62007 12.141 5.20142 10.4184 5.20142C4.6646 5.20121 0 9.86906 0 15.6271C0 21.3852 4.6646 26.0528 10.4184 26.0528H26.3827C33.5719 26.0528 39.4 20.2207 39.4 13.0264C39.4 5.83215 33.5719 0 26.3827 0Z",
    fill: "url(#paint2_linear_1640_38191)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1640_38191)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1640_38191",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 27
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3827 0C21.6277 0 17.469 2.55172 15.1973 6.36083C13.7659 5.62007 12.141 5.20142 10.4184 5.20142C4.6646 5.20121 0 9.86906 0 15.6271C0 21.3852 4.6646 26.0528 10.4184 26.0528H26.3827C33.5719 26.0528 39.4 20.2207 39.4 13.0264C39.4 5.83215 33.5719 0 26.3827 0Z",
    fill: "url(#paint3_linear_1640_38191)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1640_38191)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1640_38191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8405 13.0547C30.9941 13.0547 28.5046 14.5821 27.1446 16.8624C26.2877 16.419 25.3151 16.1684 24.284 16.1684C20.8396 16.1684 18.0474 18.9626 18.0474 22.4094C18.0474 25.8562 20.8396 28.6504 24.284 28.6504H33.8405C38.144 28.6504 41.6329 25.1591 41.6329 20.8525C41.6329 16.546 38.144 13.0547 33.8405 13.0547Z",
    fill: "url(#paint4_linear_1640_38191)"
  })))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8347 19.8613C9.43062 19.8613 9.10303 19.5335 9.10303 19.1291V12.7322C9.10303 12.3278 9.43062 12 9.8347 12C10.2388 12 10.5664 12.3278 10.5664 12.7322V19.1291C10.5664 19.5335 10.2388 19.8613 9.8347 19.8613Z",
    fill: "#B5FF9C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83221 19.8622C9.64496 19.8622 9.4577 19.7907 9.31492 19.6476C9.02914 19.3617 9.02914 18.8981 9.31492 18.6121L12.5113 15.4135C12.797 15.1278 13.2603 15.1278 13.5461 15.4135C13.8318 15.6995 13.8318 16.1631 13.5461 16.4491L10.3497 19.6476C10.2069 19.7905 10.0197 19.8622 9.83241 19.8622H9.83221Z",
    fill: "#B5FF9C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86861 19.8622C9.68136 19.8622 9.49411 19.7907 9.35112 19.6476L6.15476 16.4491C5.86899 16.1631 5.86899 15.6995 6.15476 15.4135C6.44054 15.1278 6.90377 15.1278 7.18955 15.4135L10.3859 18.6121C10.6717 18.8981 10.6717 19.3617 10.3859 19.6476C10.2431 19.7905 10.0557 19.8622 9.86841 19.8622H9.86861Z",
    fill: "#B5FF9C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1640_38191",
    x: 14.0474,
    y: 9.05469,
    width: 31.5854,
    height: 23.5938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1640_38191"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1640_38191",
    x1: 37.3602,
    y1: 12.8542,
    x2: 21.4926,
    y2: 27.9264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8FF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4FF9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1640_38191",
    x1: 0,
    y1: 13,
    x2: 39,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFFF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1640_38191",
    x1: 0,
    y1: 13.0264,
    x2: 39.4,
    y2: 13.0264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1640_38191",
    x1: 0,
    y1: 13.0264,
    x2: 39.4,
    y2: 13.0264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1640_38191",
    x1: 19.8671,
    y1: 26.3462,
    x2: 40.1731,
    y2: 15.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6FF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFFF9C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDownload);
export default __webpack_public_path__ + "static/media/menu-download.db41f499a7e1603d6584fa429e441fe1.svg";
export { ForwardRef as ReactComponent };